import { render, staticRenderFns } from "./apvstruck.vue?vue&type=template&id=7b3571e0&scoped=true"
import script from "./apvstruck.vue?vue&type=script&lang=js"
export * from "./apvstruck.vue?vue&type=script&lang=js"
import style0 from "./apvstruck.vue?vue&type=style&index=0&id=7b3571e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3571e0",
  null
  
)

export default component.exports